/* eslint-disable @typescript-eslint/no-empty-function */
import { Type } from "class-transformer";
import { IsNotEmpty, IsString } from "class-validator";
import { isEqual } from "date-fns";
import i18n from "../i18n";
import { AbstractJSONModel } from "./master-model";
import { ISupervisionTimeDutiesPut, SupervisionTimeDuties } from "./supervisionTimeDuties";
export interface ISupervisionTimeSchedule {
  id: number;
  name: string;
  created_at: Date;
  updated_at: Date;
  institution_id: number;
}

export interface ISupervisionTimeSchedulePost {
  create_supervision_time_schedule: {
    name: string;
    supervision_time_duties: SupervisionTimeDuties[];
  };
}

export interface ISupervisionTimeSchedulePut {
  update_supervision_time_schedule: {
    id: number;
    name: string;
    supervision_time_duties: ISupervisionTimeDutiesPut[];
  };
}

export class SupervisionTimeSchedule extends AbstractJSONModel implements ISupervisionTimeSchedule {
  public id = -1;
  @IsString()
  @IsNotEmpty({ message: i18n.global.t("timeSchedule.nameIsRequired").toString() })
  public name = "";
  public hours = 0;
  public institution_id = -1;
  @Type(() => Date)
  public created_at: Date = new Date();
  @Type(() => Date)
  public updated_at: Date = new Date();
  public supervision_time_duties: SupervisionTimeDuties[] = [];

  public updated(): boolean {
    return !isEqual(this.created_at, this.updated_at);
  }

  public convertToPostObject(duties: SupervisionTimeDuties[]): ISupervisionTimeSchedulePost {
    const s: ISupervisionTimeSchedulePost = Object.assign({
      create_supervision_time_schedule() {}
    });
    s.create_supervision_time_schedule = {
      name: this.name,
      supervision_time_duties: duties
    };
    return s;
  }

  public convertToPutObject(duties: SupervisionTimeDuties[]): ISupervisionTimeSchedulePut {
    const s: ISupervisionTimeSchedulePut = Object.assign({
      update_supervision_time_schedule() {}
    });
    s.update_supervision_time_schedule = {
      id: this.id,
      name: this.name,
      supervision_time_duties: duties.map((d) => d.convertToPutObject())
    };
    return s;
  }

  equals(other: ISupervisionTimeSchedule): boolean {
    return other.id === this.id;
  }
}
